// extracted by mini-css-extract-plugin
export var externalLink = "_d1-0";
export var internalLinkLabel = "_d1-1";